export const CommissionNameMap = {
  ROLLING_COMMISSION: 'Entry Wise Commission',
  LOSING_COMMISSION: 'Net Losing commission',
  BET_WISE_LOSING_COMMISSION: 'Entry Wise Losing Commission',
};